import { defineComponent as _defineComponent } from 'vue'
import useEmptySearch from '@ve/components/hotel/emptySearch/common/use/useEmptySearch';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'EmptySearch',
  emits: ["select-another-date", "select-another-city", "select-specific-city"],
  setup(__props, { emit }: { emit: ({(e: 'select-another-date', event: Event): void;
          (e: 'select-another-city', event: Event): void;
          (e: 'select-specific-city', data: { event: Event, id: number }): void;
    }), expose: any, slots: any, attrs: any }) {

    

    const {
        isSearchDepartureCityFromRegion,
        isProductsOfSelectedAndOtherDatesAreEmpty,
        isProductsOfSelectedDateAreEmptyButExistsOnOtherDates,
        selectedDateText,
        otherDatesAvailableInInterval,
        isShouldRenderAnotherProductsBlock,
        isShouldRenderEmptySearchBlock,
        upperText,
        clickAnotherSpecificDateHandler,
    } = useEmptySearch();

return { __sfc: true,emit, isSearchDepartureCityFromRegion, isProductsOfSelectedAndOtherDatesAreEmpty, isProductsOfSelectedDateAreEmptyButExistsOnOtherDates, selectedDateText, otherDatesAvailableInInterval, isShouldRenderAnotherProductsBlock, isShouldRenderEmptySearchBlock, upperText, clickAnotherSpecificDateHandler }
}

})